import styled from "styled-components";

export const ExpandablePanel = styled.div`
    overflow: hidden;
    height: 0;
    transition: height .3s ease;
`;